import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../../modules/reports/maintenance_dob/stopCallsReportActions'
import * as api from '../../../api/reports/maintenance_dob/stopCalls'

function* stopCallsReportGetJobList(action) {
  try {
    const payload = yield call(api.getJobList)
    yield put({ type: constants.STOP_CALLS_REPORT_GET_JOB_LIST.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.STOP_CALLS_REPORT_GET_JOB_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* stopCallsReportGetOrganizationList(action) {
  try {
    const payload = yield call(api.getOrganizationList)
    yield put({ type: constants.STOP_CALLS_REPORT_GET_ORGANIZATION_LIST.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.STOP_CALLS_REPORT_GET_ORGANIZATION_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* stopCallsReportGetFullReport(action) {
  try {
    const payload = yield call(api.getFullReport, action.filters)
    yield put({ type: constants.STOP_CALLS_REPORT_GET_FULL_REPORT.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.STOP_CALLS_REPORT_GET_FULL_REPORT.FAILED,
      message: e.message || e
    })
  }
}

/**
 * Saga
 */
function* watchStopCallsReportGetJobList() {
  yield takeLatest(constants.STOP_CALLS_REPORT_GET_JOB_LIST.ACTION, stopCallsReportGetJobList)
}

function* watchStopCallsReportGetOrganizationList() {
  yield takeLatest(
    constants.STOP_CALLS_REPORT_GET_ORGANIZATION_LIST.ACTION,
    stopCallsReportGetOrganizationList
  )
}

function* watchStopCallsReportGetFullReport() {
  yield takeLatest(constants.STOP_CALLS_REPORT_GET_FULL_REPORT.ACTION, stopCallsReportGetFullReport)
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchStopCallsReportGetJobList),
    fork(watchStopCallsReportGetOrganizationList),
    fork(watchStopCallsReportGetFullReport)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/reports/maintenance_dob/stopCallsReportSaga.js